module.exports = __webpack_public_path__ + "static/media/face-female-2.1319f154.jpg";